import { useField } from 'formik'
import { FC, ReactNode, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { CheckBoxFormik } from '@src/components/CheckBoxFormik/CheckBoxFormik'
import style from '@src/pages/Profile/Profile.module.scss'
import { AppDispatch } from '@src/store/store'
import { setField } from '@src/store/ducks/user/thunks'

type CheckBoxContainerType = {
  id?: number,
  name: string,
  description: string | ReactNode,
  className?: string
  disabled?: boolean,
}
export const CheckBoxContainer: FC<CheckBoxContainerType> = ({
  disabled, className, id, name, description,
}) => {
  const [{ onChange, value }] = useField(name)
  const dispatch = useDispatch<AppDispatch>()
  const handleChangeField = useCallback((e) => {
    dispatch(setField(e.target.name, e.target.checked))
    onChange(e)
  }, [dispatch, onChange])

  return (
    <div className={className}>
      <CheckBoxFormik
        disabled={disabled}
        key={id}
        name={name}
        label={description}
        // value={id}
        checked={value}
        className={style.checkBoxSize}
        onChange={(e) => { handleChangeField(e) }}
      />
    </div>
  )
}
